import React, { Fragment, useState } from 'react'
import DataTable from 'react-data-table-component';
import { SearchBar } from './SearchBar';
import { ticketTableColumns, ticketTableData } from '../../../../Data/MiscellaneousData/SupportTicketData';
import { Href } from '../../../../Utils/Constants';
import { Filter } from 'react-feather';
import { Card, CardBody, Collapse, Row } from 'reactstrap';
import ProductListBody from '../../../Apps/ECommerce/ProductList/ProductListHeader/ProductListBody';

export default function TicketTable() {
    const [filteredData, setFilteredData] = useState(ticketTableData);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const handleFilterToggle = () => {
        setIsFilterOpen((prevState) => !prevState);
    };
    return (
        <Fragment>
            <div className='d-flex justify-content-between align-items-center'>
                <SearchBar data={ticketTableData} setFilteredData={setFilteredData} />
                <div className="light-box">
                    <a href={Href} onClick={handleFilterToggle}>
                        {isFilterOpen ? <i className='icon-close filter-close' /> : <Filter />}
                    </a>
                </div>
            </div>
            <Collapse className={isFilterOpen ? "show" : ""}>
                <Card className="list-product-body">
                    <CardBody>
                        <ProductListBody />
                    </CardBody>
                </Card>
            </Collapse>
            <div className="table-responsive custom-scrollbar">
                <DataTable data={filteredData} columns={ticketTableColumns} pagination striped />
            </div>
        </Fragment>
    )
}
